import { useSteps } from "../../../hooks/useSteps"
import { useEffect, useMemo, useRef, useState } from "react"
import { GoBackBtn } from "../../../components/games/GoBackBtn"
import { Modal } from "../../../components/ui/modal/Modal.js"
import { config } from "../../../config.js"

import { say } from "../../../helpers/speech.js"
import { useTranslation } from "react-i18next"
import { ElegirNombre } from "./ElegirNombre"
import { ElegirSala } from "./ElegirSala.js"
import { Esperando } from "./Esperando.js"
import toast from "react-hot-toast"

import { Tutti } from "../../../components/games/tutti/Tutti"
import { TuttiFruttiMsg } from "./TuttiFruttiMsg"

const custom_say = (text) => {
  const prompt = false,
    lang = "es",
    rate = 1.3
  say(text, prompt, lang, rate)
}

const winners2str = (ws) =>
  ws.length > 1 ? `${ws.slice(0, -1)} & ${ws.slice(-1)}` : ws[0]

export const GamePicker = () => {
  const { t } = useTranslation()

  // steps
  const [steps] = useSteps(["nombre", "sala", "ready"]),
    setNombre = steps.setter("nombre"),
    setSala = steps.setter("sala"),
    setReady = steps.setter("ready")

  // modal de fin de juego
  const showModalGanaste = useState(false),
    // , handleWin        = () => {
    //   showModalGanaste[1](true)
    // }
    footerModalCompletado = () => {
      const handleRetry = () => {
        steps.goTo(1)
        websocket.current.send(JSON.stringify({ tipo: "leave" }))
        showModalGanaste[1](false)
      }
      return (
        <>
          <button
            type="button"
            onClick={handleRetry.bind(this)}
            className="btn btn-primary">
            {t(`ui.btns.retry`)}
          </button>
        </>
      )
    }

  // modal cancelado
  const showModalCancelado = useState(false),
    [canceladoText, setCanceladoText] = useState(""),
    footerModalCancelado = () => {
      const handleRetry = () => {
        if (steps) steps.goTo(1)
        showModalGanaste[1](false)
        showModalCancelado[1](false)
      }
      return (
        <>
          <button
            type="button"
            onClick={handleRetry.bind(this)}
            className="btn btn-primary">
            {t("ui.btns.ok")}
          </button>
        </>
      )
    }

  // modal error
  const showModalError = useState(false),
    [errorText] = useState(""),
    footerModalError = () => {
      const handleRetry = () => {
        showModalError[1](false)
      }
      return (
        <>
          <button
            type="button"
            onClick={handleRetry.bind(this)}
            className="btn btn-primary">
            {t("ui.btns.ok")}
          </button>
        </>
      )
    }

  // estado
  const [me, setMe] = useState({
    id: -1,
    nick: t(`games.sea_animals.anonymous`),
  })
  const [game, setGame] = useState(null)
  const [row, setRow] = useState(null)
  const [freeze, setFreeze] = useState(false)
  const [letter, setLetter] = useState("")
  const [winners, setWinners] = useState([]),
    [status, setStatus] = useState({
      players: [],
      rooms: [],
    })
  const [dones, setDones] = useState([])

  // const resetRow = (cols) =>
  //   setRow(
  //     cols.reduce((o, key) => ({ ...o, [key]: ""}), {})
  //   )

  // socket + protocolo
  const websocket = useRef()

  const tutti = useMemo(
    () => (row) => {
      // cuando envio el tutti, qued deshabilitado el btn+inputs
      setFreeze(true)
      const msg = {
        tipo: "tutti",
        cont: {
          answers: row,
        },
      }

      websocket.current.send(JSON.stringify(msg))
      setRow(game.cols.reduce((o, key) => ({ ...o, [key]: "" }), {}))
    },
    [game?.cols, setRow]
  )

  const retry = () => {
    steps.goTo(1)
    websocket.current.send(JSON.stringify({ tipo: "leave" }))
  }

  const handleMsg = useMemo(
    () => (event) => {
      const msg = JSON.parse(event.data)
      try {
        switch (msg.tipo) {
          case "welcome":
            setMe(msg.cont)
            break

          case "update":
            setStatus(msg.cont)
            break

          case "joined":
            // msg.cont == roomid
            break

          case "letter":
            // incremento en +1 la ronda actual
            setGame((current) => ({
              ...current,
              currentRound: current.currentRound + 1,
            }))
            setLetter(msg.cont)
            // llega letra -> ahora pasa a estar habilitado
            setFreeze(false)
            // resetRow(game.cols)
            setRow(game.cols.reduce((o, key) => ({ ...o, [key]: "" }), {}))
            // msj de
            custom_say(`La letra es: ${msg.cont.toUpperCase()}`)
            setTuttiMsg(
              <>
                <h2>La letra es</h2>
                <h1>{msg.cont.toUpperCase()}</h1>
              </>
            )
            setTimeout(() => setTuttiMsg(false), 3000)
            break

          case "start":
            setGame({ ...msg.cont, currentRound: 0 })
            // resetRow(msg.cont.cols)
            setRow(msg.cont.cols.reduce((o, key) => ({ ...o, [key]: "" }), {}))
            setReady(true)
            break

          case "freeze":
            setFreeze(true)
            // { "id": 33, "nick": "fulano" }
            custom_say("¡Tutti frutti!")
            setTuttiMsg(
              <>
                <h2>{msg.cont.nick}</h2>
                <h1>Tutti Frutti!</h1>
              </>
            )
            setTimeout(() => {
              setTuttiMsg(false)
              if (msg.cont.id === me.id) return
              // si no fui yo quien dijo tutti, entonces
              // ahora envio todo lo que tenga
              // const msg = `{"tipo": "setNick", "cont": "${nombre}"}`
              // websocket.current.send(msg)
              tutti(row) // <-- se esta redifiniendo cada vez que se inserta una letra, no se podra cambiar?
              // resetRow(game.cols)
            }, 4000)
            break

          case "results":
            setDones((current) =>
              [...current].concat({
                letter: letter,
                submits: msg.cont,
              })
            )
            break

          case "winners":
            setWinners(
              msg.cont.map((id) => status.players.find((p) => p.id === id).nick)
            )
            // handleWin()
            showModalGanaste[1](true)
            break

          case "cancelled":
            setCanceladoText(msg.cont)
            showModalCancelado[1](true)
            break

          case "error":
            // seterrorText(msg.cont)
            // showModalError[1](true)
            toast.error(msg.cont)
            break

          default:
            break
        }
      } catch (err) {
        console.log(err)
      }
    },
    [
      me,
      setReady,
      showModalCancelado,
      /* showModalError, */ game,
      row /*resetRow, */,
      // cuidado con estos:
      /*handleWin,*/ showModalGanaste,
      letter,
      tutti,
      status.players,
    ]
  )

  // conexion
  useEffect(() => {
    websocket.current = new WebSocket(config.wsUrl + "/tutti")
    return () => {
      websocket.current.close()
    }
  }, [])

  // listener
  useEffect(() => {
    websocket.current.addEventListener("message", handleMsg)

    return () => {
      websocket.current.removeEventListener("message", handleMsg)
    }
  }, [me, handleMsg])

  // handlers

  // handle nombre
  const handleNombreInput = (nombre) => {
    if (nombre.length > 0) {
      const msg = `{"tipo": "setNick", "cont": "${nombre}"}`
      websocket.current.send(msg)
    }
    setNombre(nombre)
  }

  // handle sala
  const handleSalaInput = (sala) => {
    const msg = `{"tipo": "join", "cont": ${sala}}`
    websocket.current.send(msg)
    setSala(sala)
  }

  // handle
  const setStart = (cols, rounds) => {
    const msg = {
      tipo: "start",
      cont: { cols, rounds },
    }

    websocket.current.send(JSON.stringify(msg))
  }

  // step click
  const handleStepClick = (ix) => {
    // 1 es el index del paso "elegi sala" en el hook "useSteps"
    const yaHabiaElegidoLaRoom = steps.currentIx > 1,
      eligioIrAtras = ix < steps.currentIx,
      saleDeLaSala =
        (yaHabiaElegidoLaRoom && eligioIrAtras) || steps.currentIx === -1

    if (!saleDeLaSala) return

    const msg = {
      tipo: "leave",
    }

    websocket.current.send(JSON.stringify(msg))
  }

  // const {t} = useTranslation()
  // {t(`games.sea_animals.select_a_room`)}

  const [tuttiMsg, setTuttiMsg] = useState(false)

  const roll = () => {
    const msg = { tipo: "nextRound" }
    websocket.current.send(JSON.stringify(msg))
  }

  return (
    <>
      {tuttiMsg && <TuttiFruttiMsg msg={tuttiMsg} />}

      <Modal
        show={showModalGanaste}
        header={<center>{t(`games.tutti.well_done`)}</center>}
        closeBtn={true}
        body={
          <center>
            <h3>
              {winners.length > 1
                ? t(`games.tutti.winners`, { ws: winners2str(winners) })
                : t(`games.tutti.winner`, { w: winners2str(winners) })}
            </h3>
          </center>
        }
        footer={footerModalCompletado()}
      />

      <Modal
        show={showModalCancelado}
        closeBtn={false}
        header={<center>{t(`games.sea_animals.its_over`)}</center>}
        body={<center>{canceladoText}</center>}
        footer={footerModalCancelado()}
      />

      <Modal
        show={showModalError}
        closeBtn={false}
        header={<center>Error</center>}
        body={<center>{errorText}</center>}
        footer={footerModalError()}
      />

      <GoBackBtn steps={steps} onChange={handleStepClick} />

      {steps.at("nombre") && <ElegirNombre setNombre={handleNombreInput} />}

      {steps.at("sala") && (
        <ElegirSala status={status} setSala={handleSalaInput} />
      )}

      {steps.at("ready") && (
        <Esperando
          me={me}
          status={status}
          setStart={setStart}
          sala={steps.data.sala}
        />
      )}

      {steps.done && (
        <Tutti
          me={me}
          row={row}
          setRow={setRow}
          game={game}
          freeze={freeze}
          letter={letter}
          dones={dones}
          tryAgain={retry}
          setDones={setDones}
          roll={roll}
          tuttiMsg={tuttiMsg}
          onTutti={tutti}
        />
      )}
    </>
  )
}
